export const UPDATE_COMPLAINT_SELLER_SUCCESS = {
    REQUEST: 'UPDATE_COMPLAINT_SELLER_SUCCESS_REQUEST',
    SUCCESS: 'UPDATE_COMPLAINT_SELLER_SUCCESS_SUCCESS',
    FAILED: 'UPDATE_COMPLAINT_SELLER_SUCCESS_FAILED',
    ERROR: 'UPDATE_COMPLAINT_SELLER_SUCCESS_ERROR',
};

export const CLEAR_ERROR_COMPLAINT_SELLER_SUCCESS = "clearErrorComplaintSellerSuccess";
export const CLOSE_MODAL_COMPLAINT_SELLER_SUCCESS = "clearErrorComplaintSellerSuccess";